import {AppState} from '../reducer';
import {IQuestionAnswerType} from '../../incase-domain/elements/base/questionElementBase';

export const questionToastsSelector = (state: AppState): {type: IQuestionAnswerType; questionId: string}[] =>
    state.questionToastReducer.toasts;
